import { connect } from 'react-redux';
import { flowRight } from 'lodash';
import SearchBarView, { SearchButton, SearchFieldLabel, SearchFieldWrapper } from './SearchBar';
import {
    getSearchMetadata,
    getSearchParameters,
} from '../../state';
import { insuranceTypeFromSpecialtyId } from '../../../utils/insuranceTypeFrom';

import {
    updateParameters,
    updatePendingSearchParameters,
} from '../../actions';

import { trackConversion } from '../../../config/ab/actions';
import { setInsuranceType } from '@zocdoc/components/src/InsurancePicker';
import { clearCarrierAndPlan, setCarrier, setPlan } from '@zocdoc/components/src/InsurancePicker/data/dropdown-state/dropdownStateActions';
import { selectCarrier } from '@zocdoc/components/src/InsurancePicker/data/carrier';
import { selectPlan } from '@zocdoc/components/src/InsurancePicker/data/plan';
import { fetchCarriersIfNeeded } from '@zocdoc/components/src/InsurancePicker/data/carriers';
import { fetchPlansIfNeeded } from '@zocdoc/components/src/InsurancePicker/data/plans';
import { fetchPopularCarriersIfNeeded } from '@zocdoc/components/src/InsurancePicker/data/popular-carriers';
import { fetchPopularPlansIfNeeded } from '@zocdoc/components/src/InsurancePicker/data/popular-plans';
import { withAB } from '../../../config/ab';
import { shouldPersistChosenCarrier, useChevronDropdownHeader } from '../../../config/ab/selector';
import { PINA_INSURANCE_PICKER_USE_DROPDOWN_CHEVRON, PINA_INSURANCE_PICKER_PERSIST_CHOSEN_CARRIER } from '../../../config/ab/experiments';

export { SearchButton, SearchFieldLabel, SearchFieldWrapper };

export function mapStateToProps(state) {
    const metadata = getSearchMetadata(state);
    const parameters = getSearchParameters(state);

    return {
        address: parameters.address || '',
        carrierId: parameters.carrierId,
        insurancePickerErrorStateOverride: parameters.pickerErrorOverride && parameters.carrierId === '-1',
        planId: parameters.planId,
        searchQueryGuid: metadata.searchQueryGuid,
        sessionId: metadata.sessionId,
        shouldPersistChosenCarrier: shouldPersistChosenCarrier(state),
        specialtyId: parameters.specialtyId,
        specialtyInsuranceType: insuranceTypeFromSpecialtyId(parameters.specialtyId),
        trackingId: metadata.trackingId,
        useChevronDropdownHeader: useChevronDropdownHeader(state),
    };
}

export const mapDispatchToProps = {
    clearCarrierAndPlan,
    setCarrier,
    setPlan,
    selectCarrier,
    selectPlan,
    fetchCarriersIfNeeded,
    fetchPlansIfNeeded,
    fetchPopularCarriersIfNeeded,
    fetchPopularPlansIfNeeded,
    setInsuranceType,
    trackConversion,
    updateParameters,
    updatePendingSearchParameters,
};

export default flowRight(
    withAB([
        PINA_INSURANCE_PICKER_USE_DROPDOWN_CHEVRON,
        PINA_INSURANCE_PICKER_PERSIST_CHOSEN_CARRIER,
    ]),
    connect(mapStateToProps, mapDispatchToProps)
)(SearchBarView);
